// Helper function to compare two arrays for equality
export const areArraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false
  }
  return arr1.every((item, index) => item === arr2[index])
}
